<div class="content">
  <div class="container-fluid email-automation-page">
    <div class="row">
      <div class="col d-sm-flex align-items-center justify-content-between mb-4">
        <div>
          <h1 class="dashboard-title mb-1">Email Automation</h1>
          <p class="page-subtitle mb-0">
            Send office EOD eligibility reports from the locally prepared eligibility Reports folder.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card shadow-sm automation-card p-4 mb-4">
          <div class="setup-header">
            <div class="setup-icon">
              <i class="fa fa-folder-open"></i>
            </div>

            <div>
              <h5 class="mb-1">Required Desktop Folder</h5>
              <p class="text-muted mb-0">
                Create this folder on the desktop before running email automation.
              </p>
            </div>
          </div>

          <div class="folder-requirement mt-4">
            <div class="folder-tree">
              <div class="folder-root">
                <i class="fa fa-folder mr-2"></i>
                <span>eligibility Reports</span>
              </div>

              <div class="folder-child">
                <span class="tree-line"></span>
                <i class="fa fa-file-excel-o mr-2"></i>
                <div>
                  <strong>EOD report for each office</strong>
                  <small>Keep the generated EOD report file(s) required for each office.</small>
                </div>
              </div>

              <div class="folder-child">
                <span class="tree-line"></span>
                <i class="fa fa-image mr-2"></i>
                <div>
                  <strong>Logo</strong>
                  <small>Keep the logo file used by the email/report automation.</small>
                </div>
              </div>

              <div class="folder-child">
                <span class="tree-line"></span>
                <i class="fa fa-address-book mr-2"></i>
                <div>
                  <strong>Office Mail IDs</strong>
                  <small>Keep the office recipient email list/configuration inside the same folder.</small>
                </div>
              </div>
            </div>

            <div class="folder-note">
              <i class="fa fa-info-circle"></i>
              <div>
                <strong>No file upload is required on this screen.</strong>
                <span>
                  The local automation will read the required files from the desktop
                  <b>eligibility Reports</b> folder.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm automation-card p-4 mb-4">
          <div class="section-heading">
            <div>
              <h5 class="mb-1">Run Email Automation</h5>
              <p class="text-muted mb-0">
                Enter the subject date and sender mailbox credentials.
              </p>
            </div>

            <span class="local-badge">Local Automation</span>
          </div>

          <div class="automation-form-grid mt-4">
            <div class="field-wrapper">
              <label class="mb-1 font-weight-600">Email Subject Date</label>
              <input
                type="date"
                class="form-control automation-input"
                [(ngModel)]="selectedDate"
                name="selectedDate"
              />
            </div>

            <div class="field-wrapper">
              <label class="mb-1 font-weight-600">Sender Email ID</label>
              <input
                type="email"
                class="form-control automation-input"
                [(ngModel)]="senderEmail"
                name="senderEmail"
                autocomplete="username"
                placeholder="name@company.com"
              />
            </div>

            <div class="field-wrapper">
              <label class="mb-1 font-weight-600">Password</label>
              <div class="password-field">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="form-control automation-input password-input"
                  [(ngModel)]="senderPassword"
                  name="senderPassword"
                  autocomplete="current-password"
                  placeholder="Enter sender mailbox password"
                />

                <button
                  type="button"
                  class="password-toggle"
                  (click)="togglePasswordVisibility()"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                >
                  <i
                    class="fa"
                    [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                  ></i>
                </button>
              </div>
            </div>

            <div class="run-btn-wrapper">
              <label class="mb-1 d-block invisible">Run</label>
              <button
                type="button"
                class="btn btn-primary run-email-btn"
                [disabled]="!selectedDate || !senderEmail.trim() || !senderPassword || emailRunning"
                (click)="runEmailAutomation()"
              >
                <i
                  class="fa mr-2"
                  [ngClass]="emailRunning ? 'fa-spinner fa-spin' : 'fa-envelope'"
                ></i>
                {{ emailRunning ? 'Email Automation Running...' : 'Run Email Automation' }}
              </button>
            </div>
          </div>

          <div class="credential-note mt-3">
            <i class="fa fa-lock mr-2"></i>
            The password is used only for this request and is not written to the activity logs.
          </div>
        </div>

        <div class="card shadow-sm automation-card p-4">
          <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div>
              <h5 class="mb-1">Email Automation Logs</h5>
              <small class="text-muted">
                Live job status, email counts and failure details. Updates every 3 seconds while running.
              </small>
            </div>

            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="clearLogs()"
              [disabled]="!emailLogs.length"
            >
              Clear
            </button>
          </div>

          <div class="mb-3" *ngIf="emailJobId">
            <span class="badge badge-light mr-2">Job #{{ emailJobId }}</span>
            <span class="badge" [ngClass]="emailRunning ? 'badge-primary' : (emailJobStatus === 'SUCCESS' || emailJobStatus === 'COMPLETED' ? 'badge-success' : 'badge-danger')">
              {{ emailJobStatus }}
            </span>
            <div class="text-muted mt-2" *ngIf="emailStatus">
              Processed: {{ emailStatus.processedEmails || 0 }}/{{ emailStatus.totalEmails || 0 }}
              &nbsp; | &nbsp; Successful: {{ emailStatus.successfulEmails || 0 }}
              &nbsp; | &nbsp; Failed: {{ emailStatus.failedEmails || 0 }}
            </div>
          </div>

          <div class="log-container" *ngIf="emailLogs.length; else noLogs">
            <div
              class="log-item"
              *ngFor="let log of emailLogs"
              [ngClass]="{
                'log-start': log.type === 'start',
                'log-end': log.type === 'end',
                'log-info': log.type === 'info',
                'log-error': log.type === 'error'
              }"
            >
              <div class="log-time">{{ log.time }}</div>
              <div class="log-message">{{ log.message }}</div>
            </div>
          </div>

          <ng-template #noLogs>
            <div class="empty-log-state text-center">
              <div class="empty-log-icon mb-2">
                <i class="fa fa-envelope-o"></i>
              </div>
              <div class="mb-1">No email automation logs yet</div>
              <small class="text-muted">
                Run email automation to see activity here.
              </small>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
